import * as requests from './requests'
import constants from './constants'
import urls from './urls'


export async function getVentaSyncStatus(id) {
  const response = await requests.get(constants.API_URL_SYNC, `${urls.GET_VENTA_SYNC_STATUS}/${id}`)
  return { ok: response.ok, data: await response.json() }
}

export async function getAllVentaSyncStatus() {
  const response = await requests.get(constants.API_URL_SYNC, `${urls.GET_VENTA_SYNC_STATUS}`)
  return { ok: response.ok, data: await response.json() }
}

export async function getVentaSyncStatusEstadisticas() {
  const response = await requests.get(constants.API_URL_SYNC, `${urls.GET_VENTA_SYNC_STATUS_ESTADISTICAS}`)
  return { ok: response.ok, data: await response.json() }
}

export async function getActividad() {
  return requests.get(constants.API_URL_SYNC, `${urls.GET_ACTIVIDAD_SYNC}`).then(async response => {
    return { ok: response.ok, data: await response.json() }
  })
}


export async function getErroneos() {
  return requests.get(constants.API_URL_SYNC, `${urls.GET_ERRONEO_SYNC}`).then(async response => {
    return { ok: response.ok, data: await response.json() }
  })
}

export async function getErroneosByOrigenDestino(entidadOrigen, entidadDestino) {
  return requests
    .get(constants.API_URL_SYNC, `${urls.GET_ERRONEO_SYNC}/${entidadOrigen}/${entidadDestino}`)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function updateErroneo(payload) {
  return requests
    .put(constants.API_URL_SYNC, `${urls.UPDATE_ERRONEO_SYNC}`, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getProcesados() {
  return requests.get(constants.API_URL_SYNC, `${urls.GET_PROCESADO_SYNC}`).then(async response => {
    return { ok: response.ok, data: await response.json() }
  })
}

export async function getInstancias() {
  return requests.get(constants.API_URL_SYNC, `${urls.GET_INSTANCIA_SYNC}`).then(async response => {
    return { ok: response.ok, data: await response.json() }
  })
}

export async function updateInstancia(payload) {
  return requests
    .put(constants.API_URL_SYNC, `${urls.UPDATE_INSTANCIA_SYNC}`, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}
